class FilterToggle extends HTMLElement {
    constructor() {
        super()

        this.closeButton = this.querySelector('[js-filter-visibility="close"]')
        this.openButton = this.querySelector('[js-filter-visibility="open"]')
        this.toggleButton = this.querySelector('[js-filter-visibility="toggle"]')
    }

    connectedCallback() {
        const collection = document.querySelector(".collection")
        if (!collection) return

        if (this.openButton) {
            this.openButton.addEventListener("click", () => {
                collection.setAttribute("data-filter-open", "true")
            })
        }

        if (this.closeButton) {
            this.closeButton.addEventListener("click", () => {
                collection.setAttribute("data-filter-open", "false")
            })
        }

        if (this.toggleButton) {
            this.toggleButton.addEventListener("click", () => {
                const isOpen = collection.getAttribute("data-filter-open") === "true"
                collection.setAttribute("data-filter-open", String(!isOpen))
            })
        }
    }
}

customElements.define("uwp-filter-toggle", FilterToggle)
